import { Field, RadioGroup, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { FieldSet, ListFieldSection, PageSection } from 'Components/Layout';
import { toMessageProps } from 'Components/Worksheets/Core/Helpers/messageHelpers';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { ManageSeparationsButton } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components';
import { SieveAdditionFieldSet } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Components/SieveAdditionFieldSet';
import { getSeparationSieveSizeIds } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import { PercentageType } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { ISieveSize, SieveSizeId, getById } from 'Data/ViewModels/Equipment/ISieveSize';
import { Message } from 'Data/ViewModels/IApiDataModel';
import { combine } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import { pipe } from 'ramda';
import React from 'react';
import { useSelector } from 'react-redux';

let TestPreparationPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const separatingSievesList = useSelector(
    combine(
      [
        pipe(createWorksheetSelector!('', false), getSeparationSieveSizeIds),
        createWorksheetSelector!('Equipment.AllSieveSizes'),
      ],
      (ids: SieveSizeId[], allSieves: ISieveSize[]) =>
        ids.length > 0 ? ids.map((id: SieveSizeId) => getById(allSieves, id)?.Caption ?? 'Not set').join(', ') : 'None'
    )
  );

  const percentageTypeOptions: Array<{ label: string; value: PercentageType }> = [
    { label: 'Percent Passing', value: PercentageType.PassingCumulative },
    { label: 'Percent Retained', value: PercentageType.RetainedCumulative },
    { label: 'Individual Percent Retained', value: PercentageType.RetainedIndividual },
  ];

  const separatingSievesMessages = useSelector(
    pipe(
      createWorksheetSelector!('Preparation.Messages'),
      (m) => (m as Array<Message>)?.filter((m) => ['SeparatingSievesList'].includes(m.PropertyName)),
      (m) => m.map(toMessageProps)
    ),
    deepEquals
  );

  return (
    <PageSection heading="Test Preparation">
      <NamePrefixModifier appendNamePrefix="Preparation">
        <ListFieldSection>
          <Field
            input={<RadioGroup />}
            name="AreSieveMassesCumulative"
            options={[
              { label: 'Cumulative', value: true },
              { label: 'Individual', value: false },
            ]}
          />
          <Field input={<RadioGroup />} name="PercentageType" options={percentageTypeOptions} />
          <SieveAdditionFieldSet />
          <FieldSet>
            <Field
              input={<TextOutput />}
              label="Separating Sieve(s)"
              value={separatingSievesList}
              messages={separatingSievesMessages}
            />
            <div>
              <ManageSeparationsButton maxSeparations={3} defaultSieveSizes={['19_0', '2_36']} />
            </div>
          </FieldSet>
        </ListFieldSection>
      </NamePrefixModifier>
    </PageSection>
  );
};

TestPreparationPageSection = withInjectedProps(TestPreparationPageSection);

export { TestPreparationPageSection };
export default TestPreparationPageSection;
